<template>
    <div :class="wrapperClasses">
        <slot name="slotA" v-if="isTypeA && isTested"/>
        <slot name="slotB" v-else/>
    </div>
</template>

<script>
export default {
    name: "ABTestWrapper",
    props:{
        isTypeA: Boolean,
        isTested: Boolean,
        featureName: {
            type: String,
            required: true
        },
        trackingProps: Object,
        wrapperClasses: String
    },
    mounted(){
        if(this.isTested){
            const extraProps = {
                ...this.trackingProps,
                type: this.isTypeA ? "A" : "B"
            }
            
            trackEvent(`${this.featureName}ComponentView`, extraProps);
        }
    }
}
</script>